import { FileDoneOutlined, LoadingOutlined, LockOutlined } from '@ant-design/icons'
import UserIcon from '@assets/CustomIcons/user_edited.svg'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Button, Tooltip } from 'antd'
import React from 'react'

interface Props {
  lockedOrder: object | undefined
}
export function OptimizingIcon({ lockedOrder }: Props) {
  if (!lockedOrder) return null
  const { state, created_by } = lockedOrder

  const title = (
    <Vertical verticalCenter alignItems='flex-start'>
      <Horizontal className='p-1'>
        <Texto appearance='white'>Locked by Optimizer</Texto>
      </Horizontal>
      <Horizontal className='p-1'>
        <img
          src={UserIcon}
          style={{
            width: 24,
            height: 24,
          }}
          className='mr-2'
        />
        <Texto appearance='white' className='ml-2'>
          {created_by}
        </Texto>
      </Horizontal>
    </Vertical>
  )
  if (state === 'pending') {
    return (
      <Tooltip title={title} trigger='hover'>
        <GraviButton
          shape='circle'
          icon={<FileDoneOutlined />}
          className='cursor-default'
          style={{
            backgroundColor: 'var(--theme-color-1)',
            color: '#fff',
            boxShadow: 'none',
            border: 'none',
          }}
        />
      </Tooltip>
    )
  }
  return (
    <Tooltip title={title} trigger='hover'>
      <Button
        shape='circle'
        style={{
          backgroundColor: 'var(--theme-color-2)',
          color: '#fff',
          border: 'none',
          maxWidth: '25px',
          minWidth: '10px',
          boxShadow: 'none',
          maxHeight: '30px',
        }}
        icon={<LoadingOutlined spin />}
        className='cursor-default'
      />
    </Tooltip>
  )
}
